import {
  getMaterializedPage as publicGetMaterializedPage,
  searchMaterializedPages as publicSearchMaterializedPages,
} from './quickpages-materializedpages-v1-materialized-page-materialized-pages.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

/** @internal */
export const getMaterializedPage: MaybeContext<
  BuildRESTFunction<typeof publicGetMaterializedPage> &
    typeof publicGetMaterializedPage
> = /*#__PURE__*/ createRESTModule(publicGetMaterializedPage);
/** @internal */
export const searchMaterializedPages: MaybeContext<
  BuildRESTFunction<typeof publicSearchMaterializedPages> &
    typeof publicSearchMaterializedPages
> = /*#__PURE__*/ createRESTModule(publicSearchMaterializedPages);

export {
  Status,
  Type,
  SortOrder,
  SortType,
  SortDirection,
  MissingValues,
  ScalarType,
  NestedAggregationType,
  Interval,
  AggregationType,
  Mode,
  WebhookIdentityType,
} from './quickpages-materializedpages-v1-materialized-page-materialized-pages.universal.js';
export {
  MaterializedPage,
  ExtendedFields,
  Tags,
  TagList,
  PublicationDetails,
  ContentDetails,
  PageRoute,
  GetMaterializedPageRequest,
  GetMaterializedPageResponse,
  SearchMaterializedPagesRequest,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  Sorting,
  Aggregation,
  AggregationKindOneOf,
  RangeBucket,
  IncludeMissingValuesOptions,
  ValueAggregation,
  ValueAggregationOptionsOneOf,
  RangeAggregation,
  ScalarAggregation,
  DateHistogramAggregation,
  NestedAggregationItem,
  NestedAggregationItemKindOneOf,
  NestedAggregation,
  SearchDetails,
  CursorPaging,
  SearchMaterializedPagesResponse,
  PagingMetadataV2,
  Cursors,
  AggregationData,
  ValueAggregationResult,
  RangeAggregationResult,
  NestedAggregationResults,
  NestedAggregationResultsResultOneOf,
  ValueResults,
  RangeResults,
  AggregationResultsScalarResult,
  NestedValueAggregationResult,
  ValueResult,
  RangeResult,
  ScalarResult,
  NestedResultValue,
  NestedResultValueResultOneOf,
  Results,
  DateHistogramResult,
  GroupByValueResults,
  DateHistogramResults,
  NestedResults,
  AggregationResults,
  AggregationResultsResultOneOf,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  MaterializedPageSearchSpec,
} from './quickpages-materializedpages-v1-materialized-page-materialized-pages.universal.js';
export { utils } from './quickpages-materializedpages-v1-materialized-page-materialized-pages.universal.js';
export {
  StatusWithLiterals,
  TypeWithLiterals,
  SortOrderWithLiterals,
  SortTypeWithLiterals,
  SortDirectionWithLiterals,
  MissingValuesWithLiterals,
  ScalarTypeWithLiterals,
  NestedAggregationTypeWithLiterals,
  IntervalWithLiterals,
  AggregationTypeWithLiterals,
  ModeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonSearchWithEntityContext,
  MaterializedPageSearch,
} from './quickpages-materializedpages-v1-materialized-page-materialized-pages.universal.js';
